export default "__VITE_ASSET__d434f04c__"